import React from 'react';
import {CLFBDetalle} from "../types/types";
import {ITableColumn, ITableGroups, TableList} from "../../../../../components/table";
import CLFBDetalleCampoActivo from "./CLFBDetalleCampoActivo";
import CLFBDetalleCampoLimite from "./CLFBDetalleCampoLimite";
import CLFBDetalleCampoConcentracion from "./CLFBDetalleCampoConcentracion";
import CLFBDetalleCampoStopLoss from "./CLFBDetalleCampoStopLoss";
import CLFBDetalleCampoHoldingPeriod from "./CLFBDetalleCampoHoldingPeriod";
import {Box, Tooltip} from "@mui/material";
import {OperacionCLFBDetalleFields} from "../types/fields";

interface CLFBDetalleTablaProps {
    detalles?: CLFBDetalle[],
    codPais: number,
    permiteEditar: boolean,
    alGuardarDetalle: (detalle: CLFBDetalle) => void,
    adicionales?: React.ReactElement,
    isLoading: boolean,
    error: boolean,
}

function CLFBDetalleTabla({
                              detalles,
                              codPais,
                              permiteEditar,
                              alGuardarDetalle,
                              adicionales,
                              isLoading,
                              error
                          }: CLFBDetalleTablaProps) {


    const columnsTablaCLFBDetalle: ITableColumn[] = [
        {
            label: 'Activo Tipo', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Box
                        sx={{width: '250px'}}
                    >
                        <CLFBDetalleCampoActivo
                            detalle={detalle}
                            codPais={codPais}
                            permiteEditar={permiteEditar}
                            handleConfirm={alGuardarDetalle}
                        />
                    </Box>
                )
            },
            width: '250px',
            dividers: {
                right: '2px'
            }
        },
        {
            label: 'Límite Neto', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Box
                        sx={{width: '115px'}}
                    >
                        <CLFBDetalleCampoLimite
                            detalle={detalle}
                            codPais={codPais}
                            permiteEditar={permiteEditar}
                            tipoLimite={'neto'}
                            handleConfirm={alGuardarDetalle}
                        />
                    </Box>
                )
            },
            width: '115px',
        },
        {
            label: 'Límite Absoluto', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Box
                        sx={{width: '115px'}}
                    >
                        <CLFBDetalleCampoLimite
                            detalle={detalle}
                            codPais={codPais}
                            permiteEditar={permiteEditar}
                            tipoLimite={'absoluto'}
                            handleConfirm={alGuardarDetalle}
                        />
                    </Box>

                )
            },
            width: '115px',
        },
        {
            label: 'Concentración Máxima', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Box
                        sx={{width: '50px'}}
                    >
                        <CLFBDetalleCampoConcentracion
                            detalle={detalle}
                            codPais={codPais}
                            permiteEditar={permiteEditar}
                            handleConfirm={alGuardarDetalle}
                        />
                    </Box>

                )
            },

            width: '50px',
            dividers: {right: 2}
        },
        {
            label: 'Verde', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Tooltip title={detalle[OperacionCLFBDetalleFields.StopLossVerde]}>
                        <Box
                            sx={{width: '100px'}}
                        >
                            <CLFBDetalleCampoStopLoss
                                detalle={detalle}
                                permiteEditar={permiteEditar}
                                tipoStopLoss={'verde'}
                                handleConfirm={alGuardarDetalle}
                            />

                        </Box>
                    </Tooltip>

                )
            },
            width: '100px'
        },
        {
            label: 'Amarilla', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Tooltip title={detalle[OperacionCLFBDetalleFields.StopLossAmarilla]}>
                        <Box
                            sx={{width: '100px'}}
                        >

                            <CLFBDetalleCampoStopLoss
                                detalle={detalle}
                                permiteEditar={permiteEditar}
                                tipoStopLoss={'amarilla'}
                                handleConfirm={alGuardarDetalle}
                            />

                        </Box>
                    </Tooltip>

                )
            },
            width: '100px'
        },
        {
            label: 'Roja', onRenderCell: (detalle: CLFBDetalle) => {
                return (

                    <Tooltip title={detalle[OperacionCLFBDetalleFields.StopLossRoja]}>
                        <Box
                            sx={{width: '100px'}}
                        >
                            <CLFBDetalleCampoStopLoss
                                detalle={detalle}
                                permiteEditar={permiteEditar}
                                tipoStopLoss={'roja'}
                                handleConfirm={alGuardarDetalle}
                            />
                        </Box>
                    </Tooltip>
                )
            },
            width: '100px',
            dividers: {right: 2}
        },
        {
            label: 'Verde', onRenderCell: (detalle: CLFBDetalle) => {
                return (

                    <Tooltip title={detalle[OperacionCLFBDetalleFields.HoldingPeriodVerde]}>
                        <Box
                            sx={{width: '100px'}}
                        >
                            <CLFBDetalleCampoHoldingPeriod
                                detalle={detalle}
                                codPais={codPais}
                                permiteEditar={permiteEditar}
                                handleConfirm={alGuardarDetalle}
                                tipoHoldingPeriod={'verde'}
                            />
                        </Box>
                    </Tooltip>


                )
            },
            width: '100px',
        },
        {
            label: 'Amarilla', onRenderCell: (detalle: CLFBDetalle) => {
                return (
                    <Tooltip title={detalle[OperacionCLFBDetalleFields.HoldingPeriodAmarilla]}>
                        <Box
                            sx={{width: '100px'}}
                        >
                            <CLFBDetalleCampoHoldingPeriod
                                detalle={detalle}
                                codPais={codPais}
                                permiteEditar={permiteEditar}
                                handleConfirm={alGuardarDetalle}
                                tipoHoldingPeriod={'amarilla'}
                            />
                        </Box>
                    </Tooltip>

                )
            },
            width: '100px',
        },
        {
            label: 'Roja', onRenderCell: (detalle: CLFBDetalle) => {
                return (

                    <Tooltip title={detalle[OperacionCLFBDetalleFields.HoldingPeriodRoja]}>
                        <Box
                            sx={{width: '100px'}}
                        >
                            <CLFBDetalleCampoHoldingPeriod
                                detalle={detalle}
                                codPais={codPais}
                                permiteEditar={permiteEditar}
                                handleConfirm={alGuardarDetalle}
                                tipoHoldingPeriod={'roja'}
                            />
                        </Box>
                    </Tooltip>

                )
            },
            width: '100px',
        },

    ]

    const gruposTablaCLFBDetalle: ITableGroups[] = [
        {firstColumn: 0, lastColumn: 0, label: '', dividers: {right: 2}},
        {firstColumn: 1, lastColumn: 3, label: 'Credit Limits', dividers: {right: 2}},
        {firstColumn: 4, lastColumn: 6, label: 'Stop Loss', dividers: {right: 2}},
        {firstColumn: 7, lastColumn: 9, label: 'Holding Period'},
    ]


    return (
        <TableList
            entityList={detalles}
            columnGroups={gruposTablaCLFBDetalle}
            columns={columnsTablaCLFBDetalle}
            isLoading={isLoading}
            error={error}
            footer={adicionales}
        />
    );
}

export default CLFBDetalleTabla;